export const cardsMap = {
  graficoSimples: { cardId: 'graficoSimples' },
  cruzamentoSimples: { cardId: 'cruzamentoSimples' },
  graficoEvolutivo: { cardId: 'graficoEvolutivo' },
  graficoEvolutivoCruzamentos: { cardId: 'graficoEvolutivoCruzamentos' },
  cruzamentosMultiplos: { cardId: 'cruzamentosMultiplos' },
  correlacao: { cardId: 'correlacao' },
  simulacao: { cardId: 'simulacao' },
};
